// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Minus(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Minus" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M6 10.5H18V13.5H6V10.5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Minus.js.map